export default __webpack_public_path__ + "static/sizing-4d8bbe8bfd7c6b4d1c075e3f5f7e6cb1.png";